import type { ExtensionManifest } from '../types';
import { EXTENSION_MANIFESTS } from '../../../supabase/functions/_shared/extension-manifests';

// The data lives in supabase/functions/_shared/extension-manifests.ts so
// partnr-agent can read the same manifest.
export const pinterestImportManifest = EXTENSION_MANIFESTS.find(
  (m) => m.id === 'pinterest-import',
) as ExtensionManifest;
